import(/* webpackMode: "eager" */ "/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"PT_Sans_Narrow\",\"arguments\":[{\"weight\":[\"400\",\"700\"],\"subsets\":[\"latin\",\"cyrillic\"],\"variable\":\"--font-sans-narrow\"}],\"variableName\":\"sans_narrow\"}");
;
import(/* webpackMode: "eager" */ "/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"weight\":[\"400\",\"500\"],\"subsets\":[\"latin\",\"cyrillic\"],\"variable\":\"--font-montserrat\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"PT_Sans_Caption\",\"arguments\":[{\"weight\":[\"400\"],\"subsets\":[\"latin\",\"cyrillic\"],\"variable\":\"--font-sans-caption\"}],\"variableName\":\"sans_caption\"}");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/ig.svg");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/nd.svg");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/tg.svg");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/vk.svg");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/yt.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/Container/Container.module.scss");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/Footer/Footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/HeaderMenu/HeaderMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/RunningLine/RunningLine.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/libs/Noise/Noise.tsx");
;
import(/* webpackMode: "eager" */ "/frontend/src/styles/globals.scss");
